<template>
  <div style="text-align:center">
    <p>
      Прохождение теста <b>'{{ testLabel }}'</b> закончено.
    </p>
    <p>
      Вы ответили на <b>{{ testQuestionsPassedCount }}</b> из <b>{{ testQuestionsCount }}</b> вопросов.
    </p>
    <p>
      Затрачено времени: <b>{{ formattedElapsedTime }}</b>
    </p>
    <p>
      Нажмите <b>'Вперёд'</b> для продолжения сценария.
    </p>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  import time from '../../api/contest/time'
  import { mapGetters } from 'vuex'

  export default {
      name: 'testexit',
      data() {
        return {

        }
      },
      computed: {
        formattedElapsedTime: function() {
          if(this.elapsedTime && this.testTime) {
            let value = this.testTime * 60;
            if(value > this.elapsedTime)
              return time.formatMinutes(this.elapsedTime);
            return  time.formatMinutes(value);
          }
          return time.formatMinutes(null);
        },
        ...mapGetters([
          'testLabel',
          'elapsedTime',
          'testTime',
          'isContestAuthorized',
          'testQuestionsCount',
          'testQuestionsPassedCount'
        ])
      },
      created() {
        if(!this.isContestAuthorized)
          this.$router.push(config.WELCOME_URL);
      }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/contest/testexit.vue